import React, { Suspense } from 'react';
import { useAuth } from '@contexts/AuthContext';

interface AuthProtectedProps {
    children: React.ReactNode;
    fallback?: React.ReactNode;
}

const AuthProtected: React.FC<AuthProtectedProps> = ({
    children,
    fallback = <div>Loading...</div>
}) => {
    const { isLoading } = useAuth();

    if (isLoading) {
        return <>{fallback}</>;
    }

    return <>{children}</>;
};

// Higher-order component for protecting components that need auth context
export const withAuthProtection = <P extends object>(
    Component: React.ComponentType<P>,
    fallback?: React.ReactNode
) => {
    const AuthProtectedComponent = (props: P) => (
        <Suspense fallback={fallback}>
            <AuthProtected fallback={fallback}>
                <Component {...props} />
            </AuthProtected>
        </Suspense>
    );

    AuthProtectedComponent.displayName = `withAuthProtection(${Component.displayName || Component.name})`;
    return AuthProtectedComponent;
};

export default AuthProtected;
